export const environment = {
  production: true,
  urlApi: 'https://nvdo.movsa.net/api/',
  urlApiTask: 'https://nvdo.movsa.net/v2/api/'
};
